<template>
    <!--
        作者：kmdshop
        时间：2019-10-24
        描述：商品管理
    -->
    <div class="product-list">
      <!--搜索表单-->
      
      <div style="float: left;width:25%;">
        <Supply_s  @handleCurrentChange="handleCurrentChangeS" @reast="reasts"></Supply_s>
    </div>
      
      <div style="float: left;width:72%;margin-left: 1%;">
        <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="商品分类">
          <el-select size="small" v-model="searchForm.category_id" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.category_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称"><el-input size="small" v-model="searchForm.product_name" placeholder="请输入商品名称"></el-input></el-form-item>
        <el-form-item label="编码"><el-input size="small" v-model="searchForm.product_no" :placeholder="product_no_search"></el-input></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column type="selection"  width="45"></el-table-column>
          <el-table-column prop="product_name" label="产品" width="200px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image.file_path?scope.row.image.file_path:(scope.row.image?scope.row.image:'')" alt="" /></div>

                <div class="info">
                  <div class="name">{{ scope.row.product_name }}</div>
                  <div class="price">￥{{ scope.row.product_price }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
   
          <el-table-column prop="spec_value" label="规格"></el-table-column>
  
          <el-table-column prop="product_price" label="价格"></el-table-column>
 
          <el-table-column prop="stock_num" label="库存"></el-table-column>
          <el-table-column prop="line_price" label="成本"></el-table-column>
          <!-- <el-table-column prop="warehousetext" width="100" label="所属库位">
            <template slot-scope="scope">
              {{ scope.row.warehousetext+"#"+scope.row.warehousekwtext }}
            </template>
            
          </el-table-column> -->
          <el-table-column prop="create_time" label="发布时间"></el-table-column>

   
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>

    <Wholesale v-if="is_open_wholesale" :is_open_wholesale="is_open_wholesale" :form="curModel" @closeDialog="closeDialogFunc($event)"></Wholesale>  
    <SetChildProduct v-if="is_open_scp" :product_sku="product_sku" :is_open_scp="is_open_scp"   @closeDialog="closeDialogFunc($event)"></SetChildProduct>
    <CheckStock v-if="showCheckStock" :showCheckStock="showCheckStock" :form="curModel" @closeDialog="closeDialogFunc($event)"></CheckStock>  
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
  

      </div>
      
  
  
  
     <Op v-if="open_op" :open_add="open_op" :product_id="productModel.product_id" 
      @closeDialog="closeDialogFunc($event, 'op')"></Op>

    </div>
  </template>
  
  <script>
  import ProductApi from '@/api/product.js';

  import Supply_s from '@/components/select/warehouse';

  import qs from 'qs';
  import Op from './dialog/Op.vue';

  import { setCookie,getCookie } from '@/utils/base';

  export default {
    components: {
      Supply_s
    },
    data() {
      return {
        isupload:false,
        is_open_wholesale:false,
        is_open_scp:false,
        showCheckStock:false,
         path_type:'',
          show_path:false,
        /*切换菜单*/
        activeName: 'all',
        /*切换选中值*/
        activeIndex: '0',
        /*是否正在加载*/
        loading: true,
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索参数*/
        searchForm: {
          product_name: '',
          category_id: '',
          delivery_id: '',
          product_no:'',
          is_special_view:'',
          brand_id:'',
          is_spec_type:"",
          supply_id:0,
        },
        /*列表数据*/
        tableData: [],
        /*全部分类*/
        categoryList: [],
        // 全部品牌
        brand_list: [],
        delivery_list: [],
        /*选中的*/
        multipleSelection: [],
        /*选择的商品列表*/
        select_list:[],
        /*是否显示*/
        dialogVisible: false,
        open_upload:false,
        // 导入类型
        import_type:'goods',
        // 是否加载操作页面
        more_actions:false,
        product_no_search:'',
        error_img:'',
        wxapp_id:'',
        remarkDialogFormVisible: false,
        remarkDialogLoading: false,
        remarkForm: {
          remark: ''
        },
        supply_id:getCookie("is_supply")?getCookie("is_supply"):0,
        supply_setting:{},

        supply:{},
        open_op: false,
   
      };
    },
    created() {
      /*获取列表*/


      this.getData();
    },
    methods: {
     
    handleCurrentChangeS(val){
        this.searchForm.warehouse_id = val.warehouse_id
        this.searchForm.warehouse_kw_id = val.warehouse_kw_id
        this.getData();
      },
      reasts(){
  
        this.searchForm.warehouse_id = 0
        this.searchForm.warehouse_kw_id = 0
        this.getData();
      },
    


      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.loading = true;
        self.curPage = val;
        self.getData();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.pageSize = val;
        this.getData();
      },
  
      /*切换菜单*/
      handleClick(tab, event) {
        let self = this;
        self.curPage = 1;
        self.getData();
      },
  
      /*获取列表*/
      getData() {
        let self = this;
        let Params = self.searchForm;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.type = self.activeName;
        self.loading = true;
        Params.is_warehouse = 1;
        ProductApi.skuList(Params, true)
        .then(data => {
          self.loading = false;
          self.categoryList = data.data.category;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
      },
  
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getData();
      },
  
      /*打开添加*/
      addClick() {
        this.$router.push('/product/product/add');
      },
      /*批量上架*/
      batch_shelves() {
          let product_ids=[];
          let params = this.multipleSelection;
          params.forEach((param)=>{
            product_ids.push(param.product_id);
          })
          product_ids=product_ids.join(',');
        // console.log(product_ids);
          if(product_ids==''){
            this.$message({
              message: '请选择要上架的商品',
              type: 'error'
            });
          }else{
            ProductApi.batchProduct({
              product_ids: product_ids
            }).then(data => {
              this.$message({
                message: '批量上架成功',
                type: 'success'
              });
              this.getData();
            });
          }
  
      },
      /*批量下架*/
      batch_UnShelve() {
        let product_ids=[];
        let params = this.multipleSelection;
        params.forEach((param)=>{
          product_ids.push(param.product_id);
        })
        product_ids=product_ids.join(',');
        if(product_ids==''){
          this.$message({
            message: '请选择要下架的商品',
            type: 'error'
          });
        }else{
          ProductApi.batch_UnshelveProduct({
            product_ids: product_ids
          }).then(data => {
            this.$message({
              message: '批量下架成功',
              type: 'success'
            });
            this.getData();
          });
        }
      },
      /*选择商品*/
      handleSelectionChange(e) {
        this.multipleSelection = e;
      },
  
  
      /*打开编辑*/
      editClick(row) {
        this.$router.push({
          path: '/product/product/edit',
          query: {
            product_id: row.product_id,
            scene: 'edit'
          }
        });
      },
  
      /*打开复制*/
      copyClick(row) {
        this.$router.push({
          path: '/product/product/edit',
          query: {
            product_id: row.product_id,
            scene: 'copy'
          }
        });
      },
  
      /*打开复制*/
      remark(row) {
        this.remarkForm.product_id = row.product_id
        this.remarkForm.remark = row.remark
        this.remarkDialogFormVisible = true
      },
  
      // 编辑备注
      editRemark() {
        let self = this
        self.remarkDialogLoading = true
        ProductApi.editRemark(this.remarkForm).then(data => {
          self.$message({
            message: data.msg,
            type: 'success'
          });
          self.remarkDialogLoading = false
          self.remarkDialogFormVisible = false
        });
      },
  
      // 商品导入
      importGoods:function(row){
        this.open_upload = true
      },
  
      // 更多操作
      moreActions:function(row){
        this.more_actions = true
      },
  
      // 商品导出
      exportGoods:function(){
        // 勾选需要导出的商品
        let product_ids = [];
        let params = this.multipleSelection;
        params.forEach((param)=>{
          product_ids.push(param.product_id);
        })
        product_ids = product_ids.join(',');
        // 筛选条件
        // 商品状态
  
        // console.log(this.searchForm)
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/product.product/exportGoods?' + qs.stringify(this.searchForm)+'&goods_ids='+product_ids;
      },
        openPopup(item,type){
          this.dataModel = item;
          this.dataModel.wxapp_id = this.wxapp_id;
          this.show_path = true;
          this.path_type = type;
        },
      /*关闭弹窗*/
      closeDialogFunc(e, f) {
          if (f == 'upload') {
              this.open_upload = e.openDialog;
              if (e.type == 'success') {
                    this.getData();
              }
          }else if(f == 'action'){
            this.more_actions = e.openDialog;
            if (e.type == 'success') {
                  this.getData();
            }
          }else if (f == 'path') {
                this.show_path = e.openDialog;
            }else if(f == 'op'){
                this.open_op = e.openDialog;
            }
      },
      /*删除*/
      delClick: function(row) {
        let self = this;
        self
          .$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
            type: 'warning'
          })
          .then(() => {
            ProductApi.delProduct({
              product_id: row.product_id
            }).then(data => {
              self.$message({
                message: '删除成功',
                type: 'success'
              });
              self.getData();
            });
          });
      },
      /*
      修改商品排序
      */
      changeProductSort(e){
        let self = this;
        let Params = {};
        Params.product_id = e.product_id;
        Params.product_sort = e.product_sort;
        Params.scene = 'sort'
        self.loading = true;
        ProductApi.editProduct(Params, true)
          .then(data => {
            self.loading = false;
  
  
          })
          .catch(error => {
            self.loading = false;
          });
      }
    }
  };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/plus/warehouse/index/warehouse_sku_product.vue